import { inject, Signal } from '@angular/core';
import { MessageBarOptions, MessageBarService } from './message-bar.service';
import { MessageBarConfig } from './data/message-bar.config';
import { Uuid } from '@softline/core';

export type CloseMessageBarFn = () => void;
export interface MessageBarRef {
  id: Uuid;
  message: Signal<string>;
  title?: Signal<string>;
  dismiss: CloseMessageBarFn;
}

export function messageFn() {
  const service = inject(MessageBarService);
  return {
    success: (message: Signal<string>, title?: Signal<string>, options?: MessageBarOptions) : MessageBarRef => {
      const uuid = service.success(message, title, options);
      return {
        id: uuid,
        message,
        title,
        dismiss: () => service.close(uuid)
      }
    },
    error: (message: Signal<string>, title?: Signal<string>, options?: MessageBarOptions) : MessageBarRef => {
      const uuid = service.error(message, title, options);
      return {
        id: uuid,
        message,
        title,
        dismiss: () => service.close(uuid)
      }
    },
    warning: (message: Signal<string>, title?: Signal<string>, options?: MessageBarOptions) : MessageBarRef => {
      const uuid = service.warning(message, title, options);
      return {
        id: uuid,
        message,
        title,
        dismiss: () => service.close(uuid)
      }
    },
    info: (message: Signal<string>, title?: Signal<string>, options?: MessageBarOptions) : MessageBarRef => {
      const uuid = service.info(message, title, options);
      return {
        id: uuid,
        message,
        title,
        dismiss: () => service.close(uuid)
      }
    },
    open: (config: MessageBarConfig): CloseMessageBarFn => {
      const uuid = service.open(config);
      return () => service.close(uuid);
    },
    loading: (message: Signal<string>, title?: Signal<string>, onDismiss?: () => void): MessageBarRef => {
      const uuid = service.loading(onDismiss, message, title);
      return {
        id: uuid,
        message,
        title,
        dismiss: () => service.close(uuid)
      }
    },
    saving: (message: Signal<string>, title?: Signal<string>, onDismiss?: () => void): MessageBarRef => {
      const uuid = service.saving(onDismiss, message, title);
      return {
        id: uuid,
        message,
        title,
        dismiss: () => service.close(uuid)
      }
    },
    /*progress: (message: string, progress: MessageBarProgress, onCancel: () => void, title?: string, options?: MessageBarOptions) => {
      const uuid = service.progress(message, title, options);
      return () => service.close(uuid);
    },*/
  }
}
